import { Subject } from "rxjs";
import { I18nHelper, Translations } from "../../Lib/Helper/I18nHelper";

import tippy from "tippy.js";
import { parse } from "node:path/posix";

export class Options {
    StartOfWeek: number = 1;
    Lang: string = 'en';
    StartDate: moment.Moment;
    EndDate?: moment.Moment;
    DatePattern: string;
    Months: number = 1;
    RootElement: string = 'calendarWrapper--trinity';
    WeekdayLegendSelector?: string = '';
};

export class InfoObject {
    Date: string;
    Price: number;
    AdditionalCellClass?: string = null;
    WeatherData?: any = null;
    TotalDiscountPercentage?: number = 0;
    PriceWithoutDiscount?: number = null;
    Currency?: string;
    ActiveClass?: string;

    OnClick?: Function;
    ParentScope: any;
}

export class WeatherData {
    classNo: number;
    minTemp: number;
    maxTemp: number;
}

export class AxCalendarTrinity {
    private Today: moment.Moment = moment();

    private CurrentMonth: number;
    private CurrentYear: number;

    private RootElement: HTMLElement;

    private Options: Options;

    public LoadingSubject: Subject<moment.Moment> = new Subject<moment.Moment>();

    constructor(private i18nHelper = new I18nHelper()) { }

    showCalendar(month?: number, year?: number, options?: Options) {
        if (options != null) {
            this.Options = options;
        }

        moment.lang(this.Options.Lang);
        moment.updateLocale(this.Options.Lang, {
            week: {
                dow: this.Options.StartOfWeek
            }
        });

        if (this.Options?.WeekdayLegendSelector != null && typeof this.Options.WeekdayLegendSelector != 'undefined') {
            let tmp: moment.Moment = moment('31-12-1993', "YYYY-MM-DD").startOf('week');

            let legend = document.querySelector(this.Options.WeekdayLegendSelector);

            if (legend != null) {
                legend.classList.add('axc__legend');

                for (let i = 0; i < 7; i++) {
                    let elem = document.createElement('div');
                    elem.classList.add('axc__row_inner');
                    elem.innerHTML = tmp.format('dd');
                    legend.appendChild(elem);

                    tmp.add(1, 'd');
                }
            }
        }

        this.renderCalendar(month, year, this.Options.Months, false);
    }

    renderCalendar(month?: number, year?: number, months?: number, append?: boolean) {
        month = month || parseInt(moment().format('MM'));
        year = year || parseInt(moment().format('YYYY'));
        months = months || 1;
        append = append || false;

        let tbl: HTMLElement = document.getElementById(this.Options.RootElement);

        if (!append) {
            tbl.innerHTML = "";
        }

        this.Today = moment();
        this.Today.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
        let startdate = null;

        for (let h = 0; h < months; h++) {
            let dt: moment.Moment = moment(year + '-' + month + '-01', "YYYY-MM-DD");

            if (this.Options.EndDate < dt) {
                break;
            }

            this.CurrentMonth = month;
            this.CurrentYear = year;

            let dateStart: number = this.Options.StartOfWeek;


            let dateTemp: moment.Moment;

            let currentWeek: number = parseInt(dt.format('w'));

            if (currentWeek < parseInt(this.Today.format('w'))) {
                startdate = this.Today.startOf('week');
            }

            let monthHeader = document.createElement("div");
            monthHeader.classList.add("axc__month-header");

            if (dt.format("MM-YYYY") == this.Today.format("MM-YYYY")) {
                monthHeader.classList.add("ax-color-primary");
            }

            monthHeader.innerHTML = dt.format("MMM YYYY");
            monthHeader.setAttribute('data-name', dt.format("MMMM"));
            monthHeader.id = `axc__month--${dt.format("MM")}-${dt.format("YYYY")}`;
            tbl.appendChild(monthHeader);

            let startOfWeekTemp: moment.Moment = dt.startOf('week');

            let cell: HTMLElement;

            let innerHead: HTMLElement = document.createElement('div');

            //Create Table Header with Day Names
            for (let j = (0 + dateStart); j < (7 + dateStart); j++) {

                innerHead.classList.add("axc__row_inner");
                cell = document.createElement("div");
                cell.classList.add("axc__cell-header");
                let weekdayName = moment().isoWeekday(j).format('ddd').toUpperCase();
                let cellText = document.createTextNode(weekdayName);
                cell.appendChild(cellText);
                innerHead.appendChild(cell);
            }

            //Searching for the Correct Week for the this month?
            while (parseInt(startOfWeekTemp.format('DD')) >= 2 && parseInt(startOfWeekTemp.format('MM')) == this.CurrentMonth) {
                dateTemp = dt.add(-1, 'd');
                currentWeek = parseInt(dateTemp.format('w'));

                startOfWeekTemp = moment().isoWeekYear(parseInt(dateTemp.format('YYYY'))).isoWeek(currentWeek).startOf('week');
            }

            //// Also show last week if the week start is on the first
            //if (parseInt(startOfWeekTemp.format('DD')) == 1 && h == 0) {
            //    dateTemp = dt.add(-1, 'd');
            //    currentWeek = parseInt(dateTemp.format('w'));
            //}

            let startOfWeek = startOfWeekTemp;

            //Iterate 6 Weeks
            for (let i = 0; i < 6; i++) {

                //Iterate 7 Days
                for (let j = 0; j < 7; j++) {
                    let displayDate: moment.Moment = startOfWeek;

                    if (startOfWeek < startdate || this.Options.EndDate < displayDate) {
                        startOfWeek.add(7, 'd');
                        continue;
                    }

                    let innerDay: HTMLElement = document.createElement('div');
                    innerDay.classList.add("axc__row_inner");

                    cell = document.createElement("div");
                    let dateHolder: HTMLElement = document.createElement("div");

                    dateHolder.classList.add("axc__cell_dateholder-inactive");

                    if ((i === 0 && parseInt(displayDate.format('M')) < month) || displayDate.format('YYYY-MM-DD') < this.Options.StartDate.format('YYYY-MM-DD')) {

                        innerDay.classList.add("axc__cell-inactive");

                        if (displayDate.format('YYYY-MM-DD') === this.Today.format('YYYY-MM-DD')) {
                            dateHolder.classList.add("axc__cell_dateholder-currentdate");
                        }

                        if (h > 0 || append) {
                            innerDay.classList.add("invisible");
                        }
                    } else {
                        innerDay.classList.add("axc__cell");
                        cell.classList.add("axc__cell_noEvent");

                        if (displayDate.format('YYYY-MM-DD') === this.Today.format('YYYY-MM-DD')) {
                            dateHolder.classList.add("axc__cell_dateholder-currentdate");
                            dateHolder.classList.remove("axc__cell_dateholder-inactive");
                        } else {
                            dateHolder.classList.add("axc__cell_dateholder");
                            dateHolder.classList.remove("axc__cell_dateholder-inactive");
                        }

                        let nextYear: number = parseInt(displayDate.format('YYYY'));

                        if ((nextYear > this.CurrentYear && parseInt(displayDate.format('M')) < month) || parseInt(displayDate.format('M')) > month) {
                            innerDay.classList.add("axc__cell-after");
                            innerDay.classList.add("axc__cell-inactive");
                            if (months > 1 || append) {
                                innerDay.classList.add("invisible");
                            }
                        } else {
                            cell.setAttribute("data-date", displayDate.format('YYYY-MM-DD'));
                        }
                    }
                    let dayNum = document.createElement("div");
                    dayNum.appendChild(document.createTextNode(displayDate.format('DD')));
                    dateHolder.appendChild(dayNum);

                    let dayName = document.createElement("div");
                    dayName.classList.add("axc__cell_dateholder--displayName");
                    const dayContent = document.createTextNode(displayDate.format('dd'));
                    dayName.appendChild(dayContent);
                    dateHolder.appendChild(dayName);

                    cell.appendChild(dateHolder);
                    innerDay.appendChild(cell);
                    startOfWeek.add(1, 'd');
                    tbl.appendChild(innerDay);
                }

                currentWeek++;

                if (parseInt(startOfWeek.format('MM')) > this.CurrentMonth || parseInt(startOfWeek.format('YYYY')) > this.CurrentYear) {
                    break;
                }
            }

            for (let i = 0; i < 7; i++) {
                let inner = document.createElement('div');
                inner.classList.add("axc__row_inner");

                let cellinner = document.createElement("div");
                inner.classList.add("axc__cell-after");
                inner.classList.add("axc__cell-inactive");
                inner.classList.add("axc__cell-after-cellfix");

                inner.appendChild(cellinner);
                tbl.appendChild(inner);
            }

            this.LoadingSubject.next(moment(year + '-' + month + '-01', "YYYY-MM-DD"));

            year = (this.CurrentMonth === 12) ? this.CurrentYear + 1 : this.CurrentYear;
            month = (this.CurrentMonth + 1) % 12;

            if (month == 0) {
                month = 12;
            }
        }

        this.RootElement = tbl;
    }

    next(append: boolean = false) {
        this.CurrentYear = (this.CurrentMonth === 12) ? this.CurrentYear + 1 : this.CurrentYear;
        this.CurrentMonth = (this.CurrentMonth + 1) % 12;

        if (this.CurrentMonth == 0) {
            this.CurrentMonth = 12;
        }

        this.renderCalendar(this.CurrentMonth, this.CurrentYear, 1, append);
    }

    previous(append: boolean = false) {
        this.CurrentYear = (this.CurrentMonth === 0) ? this.CurrentYear - 1 : this.CurrentYear;
        this.CurrentMonth = (this.CurrentMonth === 0) ? 11 : this.CurrentMonth - 1;
        this.renderCalendar(this.CurrentMonth, this.CurrentYear, 1, append);
    }

    blockCalendar() {
        $('.axc__row_inner').css("pointer-events", "none");
    }

    unblockCalendar() {
        $('.axc__row_inner').css("pointer-events", "auto");
    }

    toggleCalendarBlock(block: boolean) {
        if (block) {
            this.blockCalendar();
        } else {
            this.unblockCalendar();
        }
    }

    addInfo(infoObj: InfoObject) {
        let cell: NodeListOf<Element> = this.RootElement.querySelectorAll('[data-date="' + infoObj.Date + '"]');

        if (infoObj.AdditionalCellClass != null) {
            $(cell).addClass(infoObj.AdditionalCellClass);
        }

        if (cell.length > 0) {
            let elem = cell[0];
            $(cell).removeClass('axc__cell_noEvent');

            let infoHolderParent: HTMLElement = document.createElement('div');
            let infoHolderSecondLine: HTMLElement = document.createElement('div');
            let infoHolderThirdLine: HTMLElement = document.createElement('div');
            let infoHolderDiscount: HTMLElement = document.createElement('div');

            infoHolderSecondLine.classList.add('ngPriceHolderCalendar');

            if (infoObj.Currency != null && typeof infoObj.Currency != 'undefined') {
                let currencyInfo: HTMLElement = document.createElement('div');
                currencyInfo.classList.add('axc__cell_info-price');
                currencyInfo.appendChild(document.createTextNode(infoObj.Currency));
                infoHolderParent.appendChild(currencyInfo);
            }

            if (infoObj.WeatherData !== null && typeof infoObj.WeatherData != 'undefined' && typeof infoObj.WeatherData.WeatherImage != 'undefined' && infoObj.PriceWithoutDiscount !== null && infoObj.TotalDiscountPercentage != 0) {
                infoHolderSecondLine.appendChild(document.createTextNode(infoObj.Price.toString()));
                let priceDiscountPercentage: number = infoObj.TotalDiscountPercentage / -100;
                infoHolderDiscount.appendChild(document.createTextNode(priceDiscountPercentage + '\u0025'));
                infoHolderDiscount.classList.add('axc_WeatherDiscount');
                infoHolderParent.appendChild(infoHolderDiscount);
                infoHolderParent.appendChild(infoHolderThirdLine);
            } else {
                infoHolderSecondLine.appendChild(document.createTextNode(infoObj.Price.toString()));
            }

            let availabilityMarker: HTMLElement = document.createElement('div');
            availabilityMarker.classList.add('axc_AvailabilityMarker');
            elem.appendChild(availabilityMarker);

            infoHolderParent.appendChild(infoHolderSecondLine);
            infoHolderParent.classList.add('axc__cell_info');

            elem.appendChild(infoHolderParent);

            if (infoObj.WeatherData !== null && infoObj.WeatherData != undefined && infoObj.WeatherData) {
                let weatherHolderParent = document.createElement('div');
                let weatherImg = document.createElement('div');
                weatherImg.classList.add('axc_weatherImg');
                weatherImg.classList.add('weatherIcon_' + infoObj.WeatherData.classNo);
                let weatherHolderTemperatures = document.createElement('div');
                let weatherHolderMinTemp = document.createElement('div');
                let weatherHolderMaxTemp = document.createElement('div');
                weatherHolderMaxTemp.appendChild(document.createTextNode(infoObj.WeatherData.maxTemp + '\u00B0'));
                weatherHolderMinTemp.appendChild(document.createTextNode(infoObj.WeatherData.minTemp + '\u00B0'));
                weatherHolderTemperatures.appendChild(weatherHolderMinTemp);
                weatherHolderTemperatures.appendChild(weatherHolderMaxTemp);
                weatherHolderTemperatures.classList.add('axc_cell_temperature');
                weatherHolderParent.appendChild(weatherHolderTemperatures);
                weatherHolderParent.appendChild(weatherImg);
                weatherHolderParent.classList.add('axc__cell_weather');
                elem.appendChild(weatherHolderParent);
            }

            let that = this;

            if (infoObj.OnClick != null) {
                elem.setAttribute('data-ac', infoObj.ActiveClass);
                elem.parentElement.addEventListener("click", function () {
                    if (this.classList.contains('axc__cell-clickable')) {
                        $(that.RootElement).find('.axc__row_inner').removeClass(infoObj.ActiveClass);
                        infoObj.OnClick(this.children[0], infoObj.ParentScope);
                        this.classList.add(infoObj.ActiveClass);
                    }
                }, false);
                elem.parentElement.classList.add('axc__cell-clickable');
            }
        }
    }

    ActivateDay(date: string): void {
        let cell: NodeListOf<Element> = this.RootElement.querySelectorAll('[data-date="' + date + '"]');
        if (cell.length > 0 && !cell[0].parentElement.classList.contains('axc__cell-clickable')) {
            cell[0].parentElement.classList.add('axc__cell-clickable');
        }
    }

    /// <summary>
    /// Deactivate Click Event for given Date
    /// </summary>
    /// <param name="date">Date to be deactivate (YYYY-MM-DD)</param>
    /// <returns>If deactivate Date was currently active</returns>
    DeactivateDay(date: string): boolean {
        let cell: NodeListOf<Element> = this.RootElement.querySelectorAll('[data-date="' + date + '"]');
        if (cell.length > 0 && cell[0].parentElement.classList.contains('axc__cell-clickable')) {
            cell[0].parentElement.classList.remove('axc__cell-clickable');
            let activeClass = cell[0].getAttribute('data-ac');
            if (cell[0].parentElement.classList.contains(activeClass)) {
                cell[0].parentElement.classList.remove(activeClass);
                return true;
            }
        }
        return false;
    }

    addContingentInfo(date: string, contingentsFree: number, contingentsCountTotal: number, showContingentsAlertPercent: number, contingentsLeftText) {
        let cell: NodeListOf<Element> = this.RootElement.querySelectorAll('[data-date="' + date + '"]');
        let showContingentsAlertTrigger: number = contingentsCountTotal / 100 * showContingentsAlertPercent;

        if (contingentsFree < showContingentsAlertTrigger && cell.length > 0) {
            let infoHolderContingents = document.createElement('div');
            infoHolderContingents.classList.add('axc__cell_contingent_info');
            infoHolderContingents.classList.add('ax-contingent-alert');

            let contingentHoverAlert: HTMLElement = document.createElement('div');
            contingentHoverAlert.classList.add('ax__cell-contingent-alert-hover');
            contingentHoverAlert.appendChild(document.createTextNode(contingentsLeftText.replace("{0}", contingentsFree)));

            cell[0].appendChild(infoHolderContingents);
            cell[0].appendChild(contingentHoverAlert);
        }
    }

    addCellClass(date: string, addClass: string) {
        let cell: NodeListOf<Element> = this.RootElement.querySelectorAll('[data-date="' + date + '"]');
        $(cell).addClass(addClass);
    }

    removeCellClass(date: string, removeClass: string) {
        let cell: NodeListOf<Element> = this.RootElement.querySelectorAll('[data-date="' + date + '"]');
        $(cell).removeClass(removeClass);
    }

    removeDiscountLabel(cell: NodeListOf<Element>) {
        [].filter.call(cell, (element: HTMLElement) => {
            const discountLabel: HTMLElement = element.querySelector('.axc_discount-label');

            if (discountLabel != null) {
                discountLabel.remove();
            }
        });
    }

    removeOriginalPriceTag(cell: NodeListOf<Element>) {
        [].filter.call(cell, (element: HTMLElement) => {
            const originalPriceTag: HTMLElement = element.querySelector('.axc__cell_info-price_org');

            if (originalPriceTag != null) {
                originalPriceTag.remove();
            }
        });
    }

    renderDiscountLabel(cell: NodeListOf<Element>, discountPercent?: number) {
        if (discountPercent == null || discountPercent === 0 || isNaN(discountPercent)) {
            this.removeDiscountLabel(cell);
            return;
        };

        let discountText = `${discountPercent > 0 ? '+' : ''}${discountPercent.toString()}\u0025`;
        [].filter.call(cell, (element: HTMLElement) => {
            const discountLabel: HTMLElement = element.querySelector('.axc_discount-label');

            if (discountLabel != null) {
                discountLabel.innerHTML = discountText;
                discountLabel.classList.toggle('axc_discount-label--red', discountPercent > 0);
                return;
            }

            const infoHolderDiscount = document.createElement('div');
            infoHolderDiscount.appendChild(document.createTextNode(discountText));
            infoHolderDiscount.classList.add('axc_discount-label');
            infoHolderDiscount.classList.toggle('axc_discount-label--red', discountPercent > 0);

            element.append(infoHolderDiscount);
        });
    }

    renderOriginalPriceTag(cell: NodeListOf<Element>, price: string, priceWithoutDiscount: string) {
        [].filter.call(cell, (element: HTMLElement) => {
            if (priceWithoutDiscount == null || priceWithoutDiscount === '' || price === priceWithoutDiscount) {
                this.removeOriginalPriceTag(cell);
                return;
            };

            const discountLabel: HTMLElement = element.querySelector('.axc__cell_info-price_org');

            if (discountLabel != null) {
                discountLabel.innerHTML = priceWithoutDiscount;
                return;
            }

            const infoHolderDiscount = document.createElement('div');
            infoHolderDiscount.appendChild(document.createTextNode(priceWithoutDiscount));
            infoHolderDiscount.classList.add('axc__cell_info-price_org');

            element.querySelector('.axc__cell_info').append(infoHolderDiscount);
        });
    }

    updatePrice(date: string, price: string, priceWithoutDiscount?: string, discountPercent?: number) {
        let cell: NodeListOf<Element> = this.RootElement.querySelectorAll('[data-date="' + date + '"]');

        if (parseInt(price.replace(',', '').replace('.', '')) !== 0) {
            $(cell).find('.ngPriceHolderCalendar').html(price);
            $(cell).find('.axc__cell_info-price').show();
        }
        else {
            $(cell).find('.ngPriceHolderCalendar').html('');
            $(cell).find('.axc__cell_info-price').hide();
        }

        this.renderDiscountLabel(cell, discountPercent);
        this.renderOriginalPriceTag(cell, price, priceWithoutDiscount);
    }

    addHasTimeSlots(date: string, contingentNr: number) {
        let cell: NodeListOf<Element> = this.RootElement.querySelectorAll('[data-date="' + date + '"]');
        $(cell).data({ contingentNr: contingentNr });
    }

    addPackageInfo(date: string, packageNr: number, tariffSheetNr: number, validTimeSpan: number) {
        let cell: NodeListOf<Element> = this.RootElement.querySelectorAll('[data-date="' + date + '"]');

        $(cell).data({ packageNr: packageNr });
        $(cell).data({ tariffSheetNr: tariffSheetNr });
        $(cell).data({ validTimeSpan: validTimeSpan });
    }

    disableWholeCalendar() {
        $('.axc__cell').addClass('axc__cell_noTimeSlot').attr('data-content', this.i18nHelper.GetTranslation(Translations.SoldOut));
    }

    highlightRange(startDate: string, endDate: string) {
        this.highlightRemove();
        let start: moment.Moment = moment(startDate, "YYYY-MM-DD");
        let end: moment.Moment = moment(endDate, "YYYY-MM-DD");

        let count: number = 0;
        let cell: NodeListOf<Element>;

        for (let m = moment(start); m.diff(end, 'days') <= 0; m.add(1, 'days')) {
            cell = this.RootElement.querySelectorAll('[data-date="' + m.format('YYYY-MM-DD') + '"]');

            $(cell[0]).find(".ax-contingent-alert").addClass("axc__cell_contingent_info_active");
            $(cell[0]).find(".axc__cell_info").addClass("axc__cell_contingent_info_active");
            $(cell[0]).find(".ax__cell-contingent-alert-hover").addClass("ax__cell-contingent-alert-hover-active");

            if (cell.length > 0) {
                cell[0].parentElement.classList.add('axc__cell-highlight');
            }
            if (count == 0) {
                cell[0].parentElement.classList.add('axc__cell-highlight-start');
                cell[0].parentElement.setAttribute('data-start', moment(startDate, 'YYYY-MM-DD').format(this.Options.DatePattern));
            }

            count++;
        }

        if (cell.length > 0) {
            cell[0].parentElement.classList.add('axc__cell-highlight-end');
            cell[0].parentElement.setAttribute('data-end', moment(endDate, 'YYYY-MM-DD').format(this.Options.DatePattern));
        }
    }

    highlightRemove() {
        let calRows: HTMLCollection = this.RootElement.children;
        for (let i = 0; i < calRows.length; i++) {
            let calCols: HTMLCollection = calRows[i].children;

            $(".axc__cell_contingent_info").removeClass("axc__cell_contingent_info_active");
            $(".axc__cell_info").removeClass("axc__cell_contingent_info_active");
            $(".ax__cell-contingent-alert-hover").removeClass("ax__cell-contingent-alert-hover-active");


            for (let j = 0; j < calCols.length; j++) {
                calCols[j].classList.remove("axc__cell-highlight");
                calCols[j].classList.remove("axc__cell-highlight-start");
                calCols[j].classList.remove("axc__cell-highlight-end");
            }
        }
    }
};
